import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useAuth0 } from '@auth0/auth0-react';
import { createUploadLink } from 'apollo-upload-client';
import environment from 'environment';

interface Props {
  children: JSX.Element;
}

function AuthorizedApolloProvider({ children }: Props) {
  const { getAccessTokenSilently } = useAuth0();

  const httpLink = createUploadLink({ uri: environment.API_URI });
  const authLink = setContext(async () => {
    try {
      const token = await getAccessTokenSilently();
      return { headers: { Authorization: `Bearer ${token}` } };
    } catch {
      return { headers: {} };
    }
  });

  const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}

export default AuthorizedApolloProvider;
